import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-3" }
const _hoisted_2 = { class: "pt-2" }

import tenkoAssociationType from "@/types/responses/getIttenkoAssociation";
import ModalFlashMessage from "@/components/Common/ModalFlashMessage.vue";
import RegisterModal from "@/components/Common/RegisterModal.vue";
import { useAuth } from "@/services/user/Auth0UserProvider";
import Api from "@/services/api/ApiServiceFabrick";
import { Ref, ref, computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteModal',
  props: {
    modelValue: { type: Boolean },
    tenkoAssociation: {}
  },
  emits: ['update:modelValue', 'success', 'deleteFailed'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const { loginWithRedirect } = useAuth()
const loading: Ref<boolean> = ref(false);
const deletable: Ref<boolean> = ref(true);
const flashMessage: Ref<{ message: string, show: boolean, type: string, cancel: boolean }> = ref({
  message: '',
  show: false,
  type: '',
  cancel: false,
})

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function deleteTenkoAssociation() {
  if (!props.tenkoAssociation) {
    return;
  }
  loading.value = true
  Api().deleteTenkoAssociation(props.tenkoAssociation.id).then(() => {
    modelValue.value = false
    loading.value = false
    emits('success');
  }).catch((error) => {
    loading.value = false
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({
          appState: { targetUrl: location.pathname },
        });
        break;
      case 403:
        location.reload();
        break;
      case 404:
        deletable.value = false
        displayFlashMessage()
        break;
    }
  });
}

function displayFlashMessage() {
  flashMessage.value.message = i18n.global.t('pages.common.messages.failedRemove')
  flashMessage.value.type = 'error'
  flashMessage.value.show = true
}

function closeModal() {
  if (!deletable.value) {
    return emits('deleteFailed')
  }
  modelValue.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(RegisterModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue).value = $event)),
    title: _unref(i18n).global.t('pages.tenkoAssociation.deleteModal.title')
  }, {
    "flash-message": _withCtx(() => [
      _createVNode(ModalFlashMessage, {
        message: flashMessage.value.message,
        show: flashMessage.value.show,
        type: flashMessage.value.type,
        cancel: flashMessage.value.cancel,
        onSetShow: _cache[0] || (_cache[0] = (show) => {flashMessage.value.show = show})
      }, null, 8, ["message", "show", "type", "cancel"])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(i18n).global.t('common.confirmationModal.confirmDelete')), 1)
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_btn, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (closeModal())),
          class: "reset-btn mr-2",
          disabled: loading.value,
          style: _normalizeStyle({
            backgroundColor : loading.value ? '#B3B8BB' : ''
          })
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "style"]),
        _createVNode(_component_v_btn, {
          onClick: deleteTenkoAssociation,
          class: "bg-danger text-white",
          loading: loading.value,
          disabled: !deletable.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.deleteBtn')), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})